import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { RootState } from "store";
import { API_BASE_URL } from "config";

export const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
  credentials: "include",
  fetchFn: (input, init) => fetch(input, { ...init, cache: "no-store" }),
});
